import { Pipe, PipeTransform } from '@angular/core';

/**
 *
 * @description TranslateSplitPipe is used in order to split translation text. Main usage is to avoid
 * using innerHTML attribute where we need to render some special HTML inside the translation.
 * @example
 * en.json
 * "test.translation-key": "Test | split"
 * inside the template
 * {{ 'test.translation-key' | translate | translateSplit: 0 }} Results in 'Test'
 * <span class="cutom-styling">{{ 'test.translation-key' | translate | translateSplit: 1 }}</span>
 *
 */
@Pipe({
  name: 'translateSplit',
  standalone: false
})
export class TranslateSplitPipe implements PipeTransform {
  transform(value: string, index: number): string {
    return value?.split('|')[index];
  }
}
